<!--自定义列表高级筛选 筛选项为固定字段，筛选条件为固定条件-->
<template>
    <van-popup
        v-if="searchPopupShow"
        v-model="searchPopupShow"
        :close-on-click-overlay="false"
        :style="{ height: '60%', background: '#F7F8FA' }"
        position="bottom"
        @click-overlay="handleClickPopupClose"
        round
    >
        <div class="search_popup_header">
            <div class="arrow_left_icon">
                <van-icon v-if="conditionShowType !== 'condition'" name="arrow-left" @click="handleClickReturn" />
            </div>
            <div class="title" v-text="searchPopupTitle"></div>
            <div class="right_btn_wrap">
                <span
                    v-if="conditionShowType === 'condition' && confirmBtnShow"
                    class="clear_btn"
                    @click="handleClickClearCondition"
                    >清空</span
                >
                <span
                    v-if="conditionShowType === 'field_value' && confirmBtnShow"
                    class="confirm_btn"
                    @click="handleClickConditionConfirm"
                    >确定</span
                >
            </div>
        </div>
        <div class="search_popup_content">
            <div v-if="conditionShowType === 'condition'" class="condition_field_wrap">
                <div class="relation_text_wrap">
                    符合以下<span class="relation_text"
                        >{{ filterData.boolean === "and" ? "所有" : "任一" }}<van-icon name="arrow-down" /></span
                    >条件
                </div>
                <ul class="condition_field_list">
                    <li v-for="(item, index) in advancedFilterList" class="condition_field_item">
                        <div class="condition_field_header">
                            <span class="index_text" v-text="`条件${index + 1}`"></span>
                            <!-- <van-icon v-if="!item.common" name="cross" @click="handleClickDelCondition(item,index)"/> -->
                        </div>
                        <div class="condition_field_content">
                            <div class="left_condition_field">
                                <div class="field_wrap" @click="handleClickSelectField(item, index)">
                                    <span v-text="item.field_key ? item.field_name : '选择字段'"></span>
                                    <van-icon v-if="!item.common" name="arrow-down" />
                                </div>
                                <div class="operator_wrap" @click="handleClickSelectOperator(item, index)">
                                    <span v-text="item.operator ? operatorText(item.operator) : '选择条件类型'"></span>
                                    <!-- <van-icon name="arrow-down" /> -->
                                </div>
                                <div class="value_wrap" @click="handleClickSelectFieldValue(item, index)">
                                    <span
                                        v-text="item.field_value_text ? item.field_value_text : '请输入/请选择'"
                                    ></span>
                                    <van-icon name="arrow-down" />
                                </div>
                            </div>
                            <!-- <div>
                                <i :class="item.common?'icon-a-fenzu4501':'icon-a-fenzu458'"
                                   class="iconfont icon-a-fenzu4501"
                                   @click="handleCommonCheckChange(item)"></i>
                            </div> -->
                        </div>
                    </li>
                </ul>
                <!-- <div class="condition_add_btn" @click="handleClickAddCondition">添加</div> -->
                <div class="condition_add_btn" @click="handleAfterSendFilterData">确认</div>
            </div>
            <ul v-else-if="conditionShowType === 'relation'" class="condition_relation_list">
                <li class="condition_relation_item" @click="handleClickRelationItem('and')">所有</li>
                <li class="condition_relation_item" @click="handleClickRelationItem('or')">任一</li>
            </ul>
            <ul v-else-if="conditionShowType === 'field_select'" class="condition_fields_list">
                <li
                    v-for="item in conditionFieldList"
                    :key="item.field_key"
                    class="condition_fields_item"
                    @click="handleClickConditionFieldItem(item)"
                >
                    <span v-text="item.field_name"></span>
                    <van-icon name="arrow" />
                </li>
            </ul>
            <ul v-else-if="conditionShowType === 'operator_select'" class="condition_fields_list">
                <li
                    v-for="item in advancedFilterFields.operator_list"
                    :key="item.value"
                    class="condition_fields_item"
                    @click="handleClickConditionOperatorItem(item)"
                >
                    <span v-text="item.label"></span>
                    <van-icon name="arrow" />
                </li>
            </ul>
            <div v-else-if="conditionShowType === 'field_value'" class="condition_value_wrap">
                <ul v-if="advancedFilterFields.condition_type === 'options'" class="options_list">
                    <li
                        v-for="item in advancedFilterFields.options"
                        class="options_item"
                        @click="handleClickOptionsConditionItem(item)"
                    >
                        <span v-text="item.label"></span>
                        <van-checkbox v-model="item.checked" shape="square"></van-checkbox>
                    </li>
                </ul>
                <ul v-else-if="advancedFilterFields.condition_type === 'contact'" class="options_list">
                    <li
                        v-for="item in contactOptions"
                        class="options_item"
                        @click="handleClickContactConditionItem(item)"
                    >
                        <span v-text="item.name"></span>
                        <van-checkbox v-model="item.checked" shape="square"></van-checkbox>
                    </li>
                </ul>
                <el-input-number
                    v-else-if="advancedFilterFields.condition_type === 'number'"
                    v-model="number_field_value"
                    :controls="false"
                    :placeholder="'请输入' + advancedFilterFields.field_name"
                    size="small"
                >
                </el-input-number>
                <van-cascader
                    v-else-if="advancedFilterFields.condition_type === 'cascader'"
                    v-model="cascaderValue"
                    :closeable="false"
                    :field-names="cascaderFieldNames"
                    :options="advancedFilterFields.options"
                    active-color="#2990FF"
                    title=""
                    @finish="handleClickCascaderFinish"
                >
                </van-cascader>
                <van-cascader
                    v-else-if="advancedFilterFields.condition_type === 'department'"
                    v-model="cascaderValue"
                    :closeable="false"
                    :field-names="cascaderFieldNames"
                    :options="departmentList"
                    active-color="#2990FF"
                    title=""
                    @finish="handleClickDepartmentFinish"
                >
                </van-cascader>
                <van-cascader
                    v-else-if="advancedFilterFields.condition_type === 'address'"
                    v-model="cascaderValue"
                    :closeable="false"
                    :field-names="cascaderFieldNames"
                    :options="advancedFilterFields.options"
                    active-color="#2990FF"
                    title=""
                    @finish="handleClickAddressFinish"
                >
                </van-cascader>
                <van-calendar
                    v-else-if="advancedFilterFields.condition_type === 'date'"
                    :allow-same-day="true"
                    :max-date="dateCalendarMax"
                    :min-date="dateCalendarMin"
                    :poppable="false"
                    :show-confirm="false"
                    :show-title="false"
                    color="#1990FF"
                    type="range"
                    @confirm="handleClickRangeCalendarConfirm"
                >
                </van-calendar>
            </div>
        </div>
    </van-popup>
</template>
<script>
import {
    defaultFilterGet,
    advancedFilterAdd,
    advancedFilterDel,
    GetDepartmentList,
    GetUserList,
    getFormFields,
} from "@/api";
import { formatDate, getWorldArea } from "@/utils";
import { mapState } from "vuex";

export default {
    name: "ListAdvancedFiltering",
    props: {
        field_form: {
            type: String,
            default: () => "",
        },
        system_fields: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            filterData: {
                boolean: "and",
                custom_field: [],
                system_field: [],
                logic_field: [],
            },
            advancedFilterList: [
                // {
                //     field_key: '',
                //     field_name: '',
                //     p_field_key: '',
                //     field_value: '',
                //     field_value_text: '',
                //     field_type: '',
                //     common: false,
                // }
            ],
            conditionFieldList: {},
            departmentList: [],
            contactOptions: [],
            allOperatorList: [
                { label: "满足", value: "in" },
                { label: "不满足", value: "not in" },
                { label: "满足", value: "between" },
                { label: "不满足", value: "not between" },
                { label: "大于", value: ">" },
                { label: "大于等于", value: ">=" },
                { label: "等于", value: "=" },
                { label: "小于", value: "<" },
                { label: "小于等于", value: "<=" },
            ],
            conditionShowType: "condition",
            conditionIndex: 0,
            advancedFilterFields: {},
            number_field_value: undefined,
            contactSelected: [],
            cascaderFieldNames: {},
            cascaderValue: "",
            confirmBtnShow: true,
            dateCalendarMin: new Date("1970-01-01"),
            dateCalendarMax: new Date("2070-01-01"),
        };
    },
    computed: {
        filterCount() {
            return (
                this.filterData.custom_field.length +
                this.filterData.system_field.length +
                this.filterData.logic_field.length
            );
        },
        searchPopupTitle() {
            switch (this.conditionShowType) {
                case "condition":
                    return "筛选";
                case "relation":
                    return "条件关系";
                case "field_select":
                    return "选择字段";
                case "operator_select":
                    return "选择条件类型";
                case "field_value":
                    if (this.advancedFilterFields.condition_type === "number") {
                        return "条件值";
                    } else if (this.advancedFilterFields.condition_type === "date") {
                        return "选择日期";
                    } else if (this.advancedFilterFields.condition_type === "contact") {
                        return "选择申请人";
                    } else if (this.advancedFilterFields.condition_type === "department") {
                        return "选择部门";
                    } else {
                        return "选择条件值";
                    }
                default:
                    return "";
            }
        },
        ...mapState(["searchPopupShow"]),
    },
    created() {
        this._getFromFields();
    },
    methods: {
        handleClickPopupClose() {
            this.$store.dispatch("searchPopupShow", false);
            this.handleAfterSendFilterData();
        },
        handleClickReturn() {
            // if (this.conditionShowType === 'relation' || this.conditionShowType === 'field_select') {
            //     this.conditionShowType = 'condition'
            // } else if (this.conditionShowType === 'operator_select') {
            //     this.conditionShowType = 'field_select'
            // } else if (this.conditionShowType === 'field_value') {
            //     this.conditionShowType = 'operator_select'
            // }
            this.conditionShowType = "condition";
        },

        _getFromFields() {
            let field_list = this.system_fields;
            field_list.forEach((field) => {
                const item = {
                    ...field,
                    ...field.extend,
                };
                item.p_field_key = "";
            });
            field_list.forEach((field) => {
                const item = {
                    ...field,
                    ...field.extend,
                };
                item.p_field_key = "";
                if (
                    item.field_type === "money" ||
                    item.field_type === "compute_mode" ||
                    item.field_type === "number" ||
                    item.field_type === "rate"
                ) {
                    item.condition_type = "number";
                    item.field_value = undefined;
                    item.operator_list = [
                        { label: "大于", value: ">" },
                        { label: "大于等于", value: ">=" },
                        { label: "等于", value: "=" },
                        { label: "小于", value: "<" },
                        { label: "小于等于", value: "<=" },
                    ];
                    this.$set(this.conditionFieldList, item.field_key, item);
                } else if (item.field_type === "order_price_compute_mode") {
                    if (item.is_upper === "1") {
                        item.condition_type = "number";
                        item.field_value = undefined;
                        item.operator_list = [
                            { label: "大于", value: ">" },
                            { label: "大于等于", value: ">=" },
                            { label: "等于", value: "=" },
                            { label: "小于", value: "<" },
                            { label: "小于等于", value: "<=" },
                        ];
                        this.$set(this.conditionFieldList, item.field_key, item);
                    }
                } else if (item.field_type === "date") {
                    if (item.date_type === "year-month") {
                        item.date_type = "monthrange";
                    } else {
                        item.date_type = item.date_type + "range";
                    }
                    item.condition_type = "date";
                    item.field_value = [];
                    item.operator_list = [
                        { label: "满足", value: "between" },
                        { label: "不满足", value: "not between" },
                    ];
                    this.$set(this.conditionFieldList, item.field_key, item);
                } else if (item.field_type === "date_range") {
                    item.condition_type = "date";
                    item.field_value = [];
                    item.operator_list = [
                        { label: "满足", value: "between" },
                        { label: "不满足", value: "not between" },
                    ];
                    this.$set(this.conditionFieldList, item.field_key, item);
                } else if (item.field_type === "radio" || item.field_type === "checkbox") {
                    item.condition_type = "options";
                    item.field_value = [];
                    item.operator_list = [
                        { label: "满足", value: "in" },
                        { label: "不满足", value: "not in" },
                    ];
                    this.$set(this.conditionFieldList, item.field_key, item);
                } else if (item.field_type === "checkbox_user_tag") {
                    item.condition_type = "options";
                    item.field_value = [];
                    item.operator_list = [
                        { label: "满足", value: "in" },
                        { label: "不满足", value: "not in" },
                    ];
                    item.options = [];
                    this.$set(this.conditionFieldList, item.field_key, item);
                } else if (item.field_type === "cascader") {
                    item.condition_type = "cascader";
                    item.field_value = [];
                    item.operator_list = [
                        { label: "满足", value: "in" },
                        { label: "不满足", value: "not in" },
                    ];
                    this.$set(this.conditionFieldList, item.field_key, item);
                } else if (item.field_type === "department") {
                    item.condition_type = "department";
                    if (item.system_type === "system") {
                        item.field_value = [];
                    } else {
                        item.field_value = "";
                    }
                    item.operator_list = [
                        { label: "满足", value: "in" },
                        { label: "不满足", value: "not in" },
                    ];
                    this.$set(this.conditionFieldList, item.field_key, item);
                    if (this.departmentList.length === 0) {
                        this.getDepartmentList();
                    }
                } else if (item.field_type === "contact") {
                    item.field_value = [];
                    item.condition_type = "contact";
                    item.operator_list = [
                        { label: "满足", value: "in" },
                        { label: "不满足", value: "not in" },
                    ];
                    this.$set(this.conditionFieldList, item.field_key, item);
                } else if (item.field_type === "address") {
                    item.field_value = [];
                    item.condition_type = "address";
                    item.operator_list = [
                        { label: "满足", value: "in" },
                        { label: "不满足", value: "not in" },
                    ];
                    this.$set(this.conditionFieldList, item.field_key, item);
                } else if (item.field_type === "table") {
                    item._child.forEach((child_obj) => {
                        const child = {
                            ...child_obj,
                            ...child_obj.extend,
                        };
                        child.field_name = item.field_name + "." + child.field_name;
                        child.p_field_type = item.field_type;
                        if (
                            child.field_type === "number" ||
                            child.field_type === "money" ||
                            child.field_type === "compute_mode" ||
                            child.field_type === "rate"
                        ) {
                            child.condition_type = "number";
                            child.field_value = undefined;
                            child.operator_list = [
                                { label: "大于", value: ">" },
                                { label: "大于等于", value: ">=" },
                                { label: "等于", value: "=" },
                                { label: "小于", value: "<" },
                                { label: "小于等于", value: "<=" },
                            ];
                            this.$set(this.conditionFieldList, child.field_key, child);
                        } else if (child.field_type === "date") {
                            child.condition_type = "date";
                            child.field_value = "";
                            child.operator_list = [
                                { label: "满足", value: "between" },
                                { label: "不满足", value: "not between" },
                            ];
                            this.$set(this.conditionFieldList, child.field_key, child);
                        } else if (child.field_type === "date_range") {
                            child.date_type = "date";
                            child.condition_type = "date";
                            child.field_value = [];
                            child.operator_list = [
                                { label: "满足", value: "between" },
                                { label: "不满足", value: "not between" },
                            ];
                            this.$set(this.conditionFieldList, child.field_key, child);
                        } else if (child.field_type === "radio" || child.field_type === "checkbox") {
                            child.condition_type = "options";
                            child.field_value = [];
                            child.operator_list = [
                                { label: "满足", value: "in" },
                                { label: "不满足", value: "not in" },
                            ];
                            this.$set(this.conditionFieldList, child.field_key, child);
                        } else if (child.field_type === "department") {
                            child.condition_type = "department";
                            if (child.system_type === "system") {
                                child.field_value = [];
                            } else {
                                child.field_value = "";
                            }
                            child.operator_list = [
                                { label: "满足", value: "in" },
                                { label: "不满足", value: "not in" },
                            ];
                            this.$set(this.conditionFieldList, child.field_key, child);
                            if (this.departmentList.length === 0) {
                                this.getDepartmentList();
                            }
                        } else if (child.field_type === "contact") {
                            child.condition_type = "contact";
                            child.field_value = [];
                            child.operator_list = [
                                { label: "满足", value: "in" },
                                { label: "不满足", value: "not in" },
                            ];
                            this.$set(this.conditionFieldList, child.field_key, child);
                        } else if (child.field_type === "address") {
                            child.condition_type = "address";
                            child.field_value = [];
                            child.operator_list = [
                                { label: "满足", value: "in" },
                                { label: "不满足", value: "not in" },
                            ];
                            this.$set(this.conditionFieldList, child.field_key, child);
                        }
                    });
                }
            });
            const dataList = field_list.map((item) => item.field_key);
            dataList.forEach((item) => {
                if (this.conditionFieldList.hasOwnProperty(item)) {
                    this.advancedFilterList.push({
                        field_key: this.conditionFieldList[item].field_key,
                        field_name: this.conditionFieldList[item].field_name,
                        p_field_key: this.conditionFieldList[item].p_field_key,
                        field_value: this.conditionFieldList[item].field_value,
                        operator:
                            this.conditionFieldList[item].operator_list &&
                            this.conditionFieldList[item].operator_list[0].value,
                        field_type: this.conditionFieldList[item].field_type,
                        common: true,
                        field_value_type: this.conditionFieldList[item].field_value_type
                    });
                }
            });
        },

        getContactList(keyword) {
            GetUserList({ keyword }).then((res) => {
                if (res.code === 200) {
                    this.contactOptions = res.data || [];
                } else {
                    this.$toast(res.message);
                }
            });
        },

        getDepartmentList() {
            GetDepartmentList().then((res) => {
                if (res.code === 200) {
                    this.departmentList = res.data || [];
                } else {
                    this.$toast(res.message);
                }
            });
        },

        //选择字段关系
        handleClickRelationItem(boolean) {
            this.filterData.boolean = boolean;
            this.conditionShowType = "condition";
            this.handleAfterSendFilterData();
        },

        //选择操作符事件
        handleClickConditionOperatorItem(operator) {
            this.advancedFilterList[this.conditionIndex].operator = operator.value;
            this.handleClickSelectFieldValue(this.advancedFilterList[this.conditionIndex], this.conditionIndex);
        },

        //点击打开选择条件值
        handleClickSelectFieldValue(item, index) {
            this.advancedFilterFields = this.conditionFieldList[item.field_key];
            this.conditionIndex = index;
            this.conditionShowType = "field_value";

            if (this.advancedFilterFields.field_type === "department") {
                if (this.departmentList.length === 0) {
                    this.getDepartmentList();
                }
                this.cascaderFieldNames = {
                    text: "relate_name",
                    value: "relate_id",
                    children: "children",
                };
                this.confirmBtnShow = false;
            } else if (this.advancedFilterFields.field_type === "contact") {
                if (this.contactOptions.length === 0) {
                    this.getContactList();
                }
                this.confirmBtnShow = true;
            } else if (this.advancedFilterFields.field_type === "address") {
                this.cascaderFieldNames = {
                    text: "label",
                    value: "value",
                    children: "children",
                };
                this.confirmBtnShow = false;
            } else if (this.advancedFilterFields.field_type === "cascader") {
                this.cascaderFieldNames = {
                    text: "label",
                    value: "value",
                    children: "_child",
                };
                this.confirmBtnShow = false;
            } else if (this.advancedFilterFields.condition_type === "number") {
                this.number_field_value = item.field_value;
            } else if (
                this.advancedFilterFields.field_type === "date_range" ||
                this.advancedFilterFields.field_type === "date"
            ) {
                this.confirmBtnShow = false;
            }
        },

        //点击选择选项类型条件
        handleClickOptionsConditionItem(item) {
            this.advancedFilterFields.options.forEach((option) => {
                if (item.value === option.value && item.label === option.label) {
                    this.$set(option, "checked", !item.checked);
                } else {
                    this.$set(option, "checked", false);
                }
            });
        },

        //点击选择联系人类型条件
        handleClickContactConditionItem(item) {
            this.contactOptions.forEach((option) => {
                if (item.uid == option.uid) {
                    this.$set(option, "checked", !item.checked);
                } else {
                    this.$set(option, "checked", false);
                }
            });
            this.$nextTick(() => {
                this.contactSelected = this.contactOptions.filter((contact) => contact.checked);
            });
        },

        //选择级联类型条件
        handleClickCascaderFinish(data) {
            this.advancedFilterList[this.conditionIndex].field_value = [data.value];
            this.advancedFilterList[this.conditionIndex].field_value_text = data.selectedOptions
                .map((option) => option.label)
                .join("/");
            this.conditionShowType = "condition";
            this.confirmBtnShow = true;
        },

        //选择部门类型条件
        handleClickDepartmentFinish(data) {
            this.advancedFilterList[this.conditionIndex].field_value = [data.value];
            this.advancedFilterList[this.conditionIndex].field_value_text = data.selectedOptions
                .map((option) => option.relate_name)
                .join("/");
            this.conditionShowType = "condition";
            this.confirmBtnShow = true;
        },

        //选择地址类型条件
        handleClickAddressFinish(data) {
            this.advancedFilterList[this.conditionIndex].field_value = [data.value];
            this.advancedFilterList[this.conditionIndex].field_value_text = data.selectedOptions
                .map((option) => option.label)
                .join("/");
            this.conditionShowType = "condition";
            this.confirmBtnShow = true;
        },

        //日期区间确定事件
        handleClickRangeCalendarConfirm(range) {
            const [start, end] = range;
            let value = [formatDate(start, "date"), formatDate(end, "date")];
            this.advancedFilterList[this.conditionIndex].field_value = value;
            this.advancedFilterList[this.conditionIndex].field_value_text = value.join("～").replace(/-/g, "/");
            this.conditionShowType = "condition";
            this.confirmBtnShow = true;
        },

        //条件值确定事件
        handleClickConditionConfirm() {
            if (this.advancedFilterFields.condition_type === "options") {
                const checkedList = this.advancedFilterFields.options.filter((item) => item.checked);
                if (checkedList.length === 0) return this.$toast("请选择条件值");
                this.advancedFilterList[this.conditionIndex].field_value = checkedList.map((item) => item.value);
                this.advancedFilterList[this.conditionIndex].field_value_text = checkedList
                    .map((item) => item.label)
                    .join();
            } else if (this.advancedFilterFields.condition_type === "contact") {
                if (this.contactSelected.length === 0) return this.$toast("请选择联系人");
                this.advancedFilterList[this.conditionIndex].field_value = this.contactSelected.map((item) => item.uid);
                this.advancedFilterList[this.conditionIndex].field_value_text = this.contactSelected
                    .map((item) => item.name)
                    .join();
                this.contactSelected = [];
            } else if (this.advancedFilterFields.condition_type === "number") {
                if (!this.number_field_value) return this.$toast("请输入条件值");
                this.advancedFilterList[this.conditionIndex].field_value = this.number_field_value;
                this.advancedFilterList[this.conditionIndex].field_value_text = this.number_field_value;
                this.number_field_value = undefined;
            }
            this.conditionShowType = "condition";
        },

        //条件类型转文字
        operatorText(operator) {
            return this.allOperatorList.find((item) => item.value === operator)
                ? this.allOperatorList.find((item) => item.value === operator).label
                : "";
        },

        //点击添加条件
        handleClickAddCondition() {
            this.advancedFilterList.push({
                field_key: "",
                field_name: "",
                p_field_key: "",
                field_value: "",
                field_value_text: "",
                field_type: "",
                operator: "",
                common: false,
            });
        },

        //删除筛选条件
        handleClickDelCondition(item, index) {
            if (item.common) return false;
            this.advancedFilterList.splice(index, 1);
            this.handleAfterSendFilterData();
        },

        //清空筛选条件
        handleClickClearCondition() {
            if (this.advancedFilterList.some((item) => item.common)) {
                this.advancedFilterList = this.advancedFilterList.filter((item) => item.common);
                this.advancedFilterList.forEach((item) => {
                    item.operator = "";
                    item.field_value = "";
                });
            } else {
                this.advancedFilterList = [
                    {
                        field_key: "",
                        field_name: "",
                        p_field_key: "",
                        field_value: "",
                        field_value_text: "",
                        field_type: "",
                        operator: "",
                        common: false,
                    },
                ];
            }
            this.handleAfterSendFilterData();
        },

        //切换常用事件
        handleCommonCheckChange(item) {
            if (!item.field_key) return false;
            item.common = !item.common;
            if (item.common) {
                advancedFilterAdd({
                    field_form: this.field_form,
                    field_key: item.field_key,
                }).then((res) => {
                    if (res.code === 200) {
                        this.$toast("设置成功");
                    } else {
                        this.$toast(res.message);
                    }
                });
            } else {
                advancedFilterDel({
                    field_form: this.field_form,
                    field_key: item.field_key,
                }).then((res) => {
                    if (res.code === 200) {
                        this.$toast("设置成功");
                    } else {
                        this.$toast(res.message);
                    }
                });
            }
        },

        //字段值操作完成后将筛选数据传递给父组件
        handleAfterSendFilterData() {
            this.filterData.custom_field = [];
            this.filterData.system_field = [];
            this.filterData.logic_field = [];
            this.advancedFilterList.forEach((item) => {
                if (
                    (Array.isArray(item.field_value) && item.field_value.length) ||
                    (!Array.isArray(item.field_value) && item.field_value !== undefined)
                ) {
                    if (item.p_field_key) {
                        if (item.system_type) {
                            if (item.system_type === "system") {
                                this.filterData.system_field.push({
                                    operator: item.operator,
                                    field_key: [item.p_field_key, item.field_key],
                                    field_value: item.field_value,
                                    field_type: item.field_type,
                                    field_value_type: item.field_value_type
                                });
                            } else {
                                this.filterData.logic_field.push({
                                    operator: item.operator,
                                    field_key: [item.p_field_key, item.field_key],
                                    field_value: item.field_value,
                                    field_type: item.field_type,
                                    field_value_type: item.field_value_type
                                });
                            }
                        } else {
                            this.filterData.custom_field.push({
                                operator: item.operator,
                                field_key: [item.p_field_key, item.field_key],
                                field_value: item.field_value,
                                field_type: item.field_type,
                                field_value_type: item.field_value_type
                            });
                        }
                    } else {
                        if (item.system_type) {
                            if (item.system_type === "system") {
                                this.filterData.system_field.push({
                                    operator: item.operator,
                                    field_key: item.field_key,
                                    field_value: item.field_value,
                                    field_type: item.field_type,
                                    field_value_type: item.field_value_type
                                });
                            } else {
                                this.filterData.logic_field.push({
                                    operator: item.operator,
                                    field_key: item.field_key,
                                    field_value: item.field_value,
                                    field_type: item.field_type,
                                    field_value_type: item.field_value_type
                                });
                            }
                        } else {
                            this.filterData.custom_field.push({
                                operator: item.operator,
                                field_key: item.field_key,
                                field_value: item.field_value,
                                field_type: item.field_type,
                                field_value_type: item.field_value_type
                            });
                        }
                    }
                }
            });
            this.$emit("sendFilterData", this.filterData);
        },
    },
};
</script>
<style lang="scss" scoped>
.search_popup_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    line-height: 24px;

    .arrow_left_icon {
        width: 16px;
        height: 16px;
    }

    .van-icon-arrow-left {
        color: #666666;
        font-size: 16px;
    }

    .title {
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        color: #333333;
    }

    .right_btn_wrap {
        .clear_btn {
            color: #e44144;
            line-height: 24px;
            font-size: 16px;
        }

        .confirm_btn {
            color: #2990ff;
            line-height: 24px;
            font-size: 16px;
        }
    }
}

.search_popup_content {
    padding: 0 16px 12px;
    height: calc(100% - 48px);

    .condition_field_wrap {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;

        .relation_text_wrap {
            padding: 10px;
            border-radius: 6px;
            background: #ffffff;
            margin-bottom: 10px;

            .relation_text {
                margin: 0 8px;
                padding: 0 8px;
                border-radius: 4px;
                background: #f7f8fa;
                line-height: 22px;
                display: inline-block;

                .van-icon-arrow-down {
                    margin-left: 8px;
                    color: #999999;
                }
            }
        }

        .condition_field_list {
            flex: 1;
            overflow-y: auto;

            .condition_field_item {
                padding: 10px;
                margin-bottom: 10px;
                border-radius: 6px;
                background: #ffffff;

                .condition_field_header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 14px;

                    .index_text {
                        font-size: 12px;
                        line-height: 18px;
                        color: #999999;
                    }

                    .van-icon-cross {
                        font-size: 16px;
                        color: #666666;
                    }
                }

                .condition_field_content {
                    display: flex;
                    align-items: center;
                    gap: 10px;

                    .left_condition_field {
                        flex: 1;
                        display: flex;
                        align-items: center;
                        gap: 6px;
                        flex-wrap: wrap;

                        .van-icon-arrow-down {
                            font-size: 12px;
                            margin-left: 6px;
                        }

                        & > div {
                            padding: 2px 6px 2px 8px;
                            border-radius: 4px;
                            background: #f7f8fa;
                        }
                    }

                    .icon-a-fenzu4501 {
                        font-size: 16px;
                        color: #2990f0;
                    }

                    .icon-a-fenzu458 {
                        font-size: 16px;
                        color: #666666;
                    }
                }
            }
        }
    }

    .condition_relation_list {
        background: #ffffff;
        border-radius: 4px;

        .condition_relation_item {
            padding: 10px 16px;
            font-size: 16px;
            line-height: 24px;
            color: #333333;

            &:first-child {
                border-bottom: 1px solid #e8e8e8;
            }

            &:active {
                background-color: rgba(153, 153, 153, 0.04);
            }
        }
    }

    .condition_fields_list {
        height: 100%;
        overflow-y: auto;

        .condition_fields_item {
            border-radius: 6px;
            background: #ffffff;
            padding: 10px 16px;
            font-size: 16px;
            line-height: 24px;
            color: #333333;
            border-bottom: 1px solid #e8e8e8;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .van-icon-arrow {
                color: #999999;
            }

            &:active {
                background-color: rgba(153, 153, 153, 0.04);
            }
        }
    }

    .condition_value_wrap {
        width: 100%;
        height: 100%;

        .options_list {
            background: #ffffff;
            border-radius: 10px;
            overflow-y: auto;
            max-height: 100%;

            .options_item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 10px 16px;
                border-bottom: 1px solid #e8e8e8;

                &:active {
                    background-color: rgba(153, 153, 153, 0.04);
                }
            }
        }

        ::v-deep .el-input-number {
            width: 100%;

            .el-input__inner {
                text-align: left;
            }
        }

        ::v-deep .van-cascader {
            .van-cascader__header {
                display: none;
            }

            .van-cascader__option {
                background: #ffffff;
            }
        }
    }

    .condition_add_btn {
        color: #2990f0;
        border-radius: 10px;
        background: #ffffff;
        padding: 10px 0;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        margin-top: 10px;
    }
}
</style>
